import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, var(--background-secondary, var(--bg-secondary)) 0%, var(--background-primary, var(--bg-primary)) 100%);
  padding: 5rem 1rem 2rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 2rem 0.75rem;
  }
`;

const Card = styled.div`
  background: var(--background-primary, var(--bg-primary));
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  max-width: 520px;
  width: 100%;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);

  h2 {
    margin: 0 0 6px;
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--text-primary);
  }

  @media (max-width: 480px) {
    padding: 1.25rem;
  }
`;

const SuccessBanner = styled.div`
  padding: 14px 16px;
  border-radius: 10px;
  background: rgba(56, 161, 105, 0.1);
  border: 1px solid var(--success-color);
  color: var(--success-dark, var(--success-color));
  font-weight: 600;
  font-size: 14px;
`;

const InfoBanner = styled.div`
  padding: 14px 16px;
  border-radius: 10px;
  background: var(--background-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
`;

export { Container, Card, SuccessBanner, InfoBanner };
